//
// Copyright 2021 DXOS.org
//
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_dxos_error } from "../error_pb.js";
/**
 * Describes the file dxos/client/logging.proto.
 */
export const file_dxos_client_logging = /*@__PURE__*/ fileDesc("ChlkeG9zL2NsaWVudC9sb2dnaW5nLnByb3RvEhRkeG9zLmNsaWVudC5zZXJ2aWNlcyLBAgoQUXVlcnlMb2dzUmVxdWVzdBI+CgdmaWx0ZXJzGAEgAygLMi0uZHhvcy5jbGllbnQuc2VydmljZXMuUXVlcnlMb2dzUmVxdWVzdC5GaWx0ZXISTAoHb3B0aW9ucxgKIAEoDjI2LmR4b3MuY2xpZW50LnNlcnZpY2VzLlF1ZXJ5TG9nc1JlcXVlc3QuTWF0Y2hpbmdPcHRpb25zSACIAQEaWQoGRmlsdGVyEi0KBWxldmVsGAEgASgOMh4uZHhvcy5jbGllbnQuc2VydmljZXMuTG9nTGV2ZWwSFAoHcGF0dGVybhgCIAEoCUgAiAEBQgoKCF9wYXR0ZXJuIjgKD01hdGNoaW5nT3B0aW9ucxIICgROT05FEAASDQoJSU5DTFVTSVZFEAESDAoIRVhQTElDSVQQAkIKCghfb3B0aW9ucyKsAwoITG9nRW50cnkSLQoFbGV2ZWwYASABKA4yHi5keG9zLmNsaWVudC5zZXJ2aWNlcy5Mb2dMZXZlbBIPCgdtZXNzYWdlGAIgASgJEi0KB2NvbnRleHQYAyABKAsyFy5nb29nbGUucHJvdG9idWYuU3RydWN0SACIAQESNgoEbWV0YRgEIAEoCzIjLmR4b3MuY2xpZW50LnNlcnZpY2VzLkxvZ0VudHJ5Lk1ldGFIAYgBARIlCgVlcnJvchgFIAEoCzIRLmR4b3MuZXJyb3IuRXJyb3JIAogBARItCgl0aW1lc3RhbXAYBiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wGoMBCgRNZXRhEgwKBGZpbGUYASABKAkSDAoEbGluZRgCIAEoBRIrCgVzY29wZRgDIAEoCzIXLmdvb2dsZS5wcm90b2J1Zi5TdHJ1Y3RIAIgBARIYCgtyZXNvdXJjZV9pZBgEIAEoBUgBiAEBQggKBl9zY29wZUIOCgxfcmVzb3VyY2VfaWRCCgoIX2NvbnRleHRCBwoFX21ldGFCCAoGX2Vycm9yKlYKCExvZ0xldmVsEggKBE5PTkUQABIJCgVUUkFDRRAFEgkKBURFQlVHEAoSCwoHVkVSQk9TRRALEggKBElORk8QDBIICgRXQVJOEA0SCQoFRVJST1IQDmIGcHJvdG8z", [file_google_protobuf_struct, file_google_protobuf_timestamp, file_dxos_error]);
/**
 * Describes the message dxos.client.services.QueryLogsRequest.
 * Use `create(QueryLogsRequestSchema)` to create a new message.
 */
export const QueryLogsRequestSchema = /*@__PURE__*/ messageDesc(file_dxos_client_logging, 0);
/**
 * Describes the message dxos.client.services.QueryLogsRequest.Filter.
 * Use `create(QueryLogsRequest_FilterSchema)` to create a new message.
 */
export const QueryLogsRequest_FilterSchema = /*@__PURE__*/ messageDesc(file_dxos_client_logging, 0, 0);
/**
 * @generated from enum dxos.client.services.QueryLogsRequest.MatchingOptions
 */
export var QueryLogsRequest_MatchingOptions;
(function (QueryLogsRequest_MatchingOptions) {
    /**
     * @generated from enum value: NONE = 0;
     */
    QueryLogsRequest_MatchingOptions[QueryLogsRequest_MatchingOptions["NONE"] = 0] = "NONE";
    /**
     * / Filters match all log levels above. Default behaviour for the logger.
     *
     * @generated from enum value: INCLUSIVE = 1;
     */
    QueryLogsRequest_MatchingOptions[QueryLogsRequest_MatchingOptions["INCLUSIVE"] = 1] = "INCLUSIVE";
    /**
     * / Explicitly specify all desired log levels.
     *
     * @generated from enum value: EXPLICIT = 2;
     */
    QueryLogsRequest_MatchingOptions[QueryLogsRequest_MatchingOptions["EXPLICIT"] = 2] = "EXPLICIT";
})(QueryLogsRequest_MatchingOptions || (QueryLogsRequest_MatchingOptions = {}));
/**
 * Describes the enum dxos.client.services.QueryLogsRequest.MatchingOptions.
 */
export const QueryLogsRequest_MatchingOptionsSchema = /*@__PURE__*/ enumDesc(file_dxos_client_logging, 0, 0);
/**
 * Describes the message dxos.client.services.LogEntry.
 * Use `create(LogEntrySchema)` to create a new message.
 */
export const LogEntrySchema = /*@__PURE__*/ messageDesc(file_dxos_client_logging, 1);
/**
 * Describes the message dxos.client.services.LogEntry.Meta.
 * Use `create(LogEntry_MetaSchema)` to create a new message.
 */
export const LogEntry_MetaSchema = /*@__PURE__*/ messageDesc(file_dxos_client_logging, 1, 0);
/**
 * NOTE: Keep aligned with LogLevel in @dxos/log.
 *
 * @generated from enum dxos.client.services.LogLevel
 */
export var LogLevel;
(function (LogLevel) {
    /**
     * @generated from enum value: NONE = 0;
     */
    LogLevel[LogLevel["NONE"] = 0] = "NONE";
    /**
     * @generated from enum value: TRACE = 5;
     */
    LogLevel[LogLevel["TRACE"] = 5] = "TRACE";
    /**
     * @generated from enum value: DEBUG = 10;
     */
    LogLevel[LogLevel["DEBUG"] = 10] = "DEBUG";
    /**
     * @generated from enum value: VERBOSE = 11;
     */
    LogLevel[LogLevel["VERBOSE"] = 11] = "VERBOSE";
    /**
     * @generated from enum value: INFO = 12;
     */
    LogLevel[LogLevel["INFO"] = 12] = "INFO";
    /**
     * @generated from enum value: WARN = 13;
     */
    LogLevel[LogLevel["WARN"] = 13] = "WARN";
    /**
     * @generated from enum value: ERROR = 14;
     */
    LogLevel[LogLevel["ERROR"] = 14] = "ERROR";
})(LogLevel || (LogLevel = {}));
/**
 * Describes the enum dxos.client.services.LogLevel.
 */
export const LogLevelSchema = /*@__PURE__*/ enumDesc(file_dxos_client_logging, 0);
//# sourceMappingURL=logging_pb.js.map